import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {useTranslation} from "react-i18next";
import {useActionContext} from "@context/actionContext/hooks/useActionContext";
import {sx} from './sx'

const Confirm = () => {

    const {confirm, setConfirm} = useActionContext()
    const {
        open,
        message,
        callback,
        cancelCallback,
        title,
        variant,
    } = confirm;

    const {t} = useTranslation()

    const isDanger = variant === 'danger'

    const handleClose = () => {
        if(typeof cancelCallback === 'function'){
            cancelCallback()
        }
        setConfirm({
            open: false,
            message:'',
            title:'',
            callback:()=>{},
            cancelCallback:null,
            variant:'default'
        })
    };
    const onAgree = async () => {
        try {
            await callback();
        } catch (e) {
            throw e;
        } finally {
            setConfirm({
                open: false,
                message:'',
                title:'',
                callback:()=>{},
                cancelCallback:null,
                variant:'default'
            })
        }
    };

    if (!open) {
        return
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={isDanger ? {sx: sx.dangerPaper} : undefined}
        >
            <DialogTitle sx={isDanger ? sx.dangerTitle : undefined}>
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    gap={'8px'}
                >
                    {isDanger && <WarningAmberIcon sx={sx.dangerIcon}/>}

                    {title || t('confirmAction')}
                </Stack>
            </DialogTitle>

            <DialogContent>
                <DialogContent>
                    <Typography sx={isDanger ? sx.dangerMessage : undefined}>
                        {message}
                    </Typography>
                </DialogContent>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('cancel')}</Button>

                <ButtonCustom
                    variant={'contained'}
                    sx={isDanger ? sx.dangerButton : undefined}
                    onClick={onAgree}
                    autoFocus
                >
                    {t('confirm')}
                </ButtonCustom>
            </DialogActions>
        </Dialog>
    );
};

export default Confirm;
